import { IRequestByPartnerId } from 'legacy/lut/classes/models/service'
import { PartnerPageMetric } from 'legacy/lut/configs/metrics'
import { fetchPartnerAttachmentsById } from 'legacy/lut/services/files'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { measureRequest } from 'shared/lib/metrics'

import { GET_PARTNER_FILES_BY_ID_REQUEST } from '../configs'
import { selectPartnerFiles } from '../selectors'

export const getPartnerFilesById = createAsyncThunk(
  GET_PARTNER_FILES_BY_ID_REQUEST,
  ({ partnerId, options }: IRequestByPartnerId, { getState }) =>
    measureRequest(PartnerPageMetric.Files, selectUser(getState()), () =>
      fetchPartnerAttachmentsById(partnerId, options)
    ),
  {
    condition({ partnerId }, { getState }) {
      if (!partnerId) {
        return false
      }

      const state = getState()
      const partnerFilesData = selectPartnerFiles(state)
      if (partnerFilesData.status === RequestStatus.PENDING) {
        return false
      }

      return true
    },
  }
)
